import { Box } from '@mui/system';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

import { IoMdAdd } from 'react-icons/io';

import {
  CustomButton,
  SubmitButton,
} from '../../../components/common/button/CustomButtons';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import { useAuth } from '../../../services/auth/AuthProvider';
import { GoSync } from 'react-icons/go';
import useConfirm from '../../../components/common/useConfirm';
import { Loader } from '../../../components/common/Loader';
import { CustomIconButton } from '../../../components/common/button/CustomIconButton';
import { MdDeleteForever } from 'react-icons/md';
import { Checkbox, Stack, Tooltip, Typography } from '@mui/material';
import { useMemo } from 'react';
import TController from './components/TController';
import useGetData from './helpers/useGetData';
import { apiConstant } from './helpers/constant';
import AutocompleteMuiCustom from '../../../components/common/AutocompleteMuiCustom';

interface MyData {
  error?: string | null;
  moduleData: any;
  isLoading: boolean;
  updateModuleData: any;
  handleDelete: any;
  skillSheetType: any;
  setTriggerRender: any;
  department: any;
  employee_id?: any;
}

const Create = () => {
  const { id: rawId, testSheetId } = useParams<{
    id: string;
    testSheetId: string;
  }>();
  const id = rawId === 'null' || rawId === 'undefined' ? undefined : rawId;
  const { state } = useAuth();
  const test_level = useQuery('test_level');
  const navigate = useNavigate();
  const isView = useQuery('isView') === 'true' ? true : false;
  const [DialogSave, confirmSave] = useConfirm(
    'SAVE',
    'Are you sure you want to Update this?'
  );
  const {
    error,
    moduleData,
    isLoading,
    updateModuleData,
    handleDelete,
    setTriggerRender,
    skillSheetType,
    department,
    employee_id,
  }: MyData = useGetData(id, testSheetId);

  const onSubmit = async (isSubmitted: boolean) => {
    const ans = await confirmSave();
    if (!ans) return;
    if (id) {
      axios
        .put(`/api/${apiConstant.update}/${id}`, moduleData)
        .then((res) => {
          alert('updated successfully ');
        })
        .catch((err) => console.log(err));
    } else {
      if (!testSheetId || !employee_id || !test_level) return;
      axios
        .post(
          `/api/${apiConstant.post}?masterSkillSheetId=${testSheetId}&employeeId=${employee_id}&testLevel=${test_level}`,
          moduleData
        )
        .then((res) => {
          alert('submitted successfully');
          navigate(-1);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <Box>
      <Box>
        <Loader loader={isLoading} />
        <ChildHeader text="">
          {!isView && (
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
              sx={{}}
            >
              <SubmitButton
                label={id ? 'Update' : 'submit'}
                onClick={() => onSubmit(true)}
              />
            </Stack>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          handleDelete,
          moduleData,
          updateModuleData,
          department,
          id,
        }}
      />
      <DialogSave isSubmitContent={false} />
    </Box>
  );
};

export default Create;
